import { useQuoteI18n } from '../quoteI18n'

/** Sotto questa soglia il conto alla rovescia diventa un avviso, non un'informazione. */
const URGENT_MS = 3 * 60 * 1000

/**
 * Conto alla rovescia per completare la prenotazione.
 *
 * Le tariffe di viaggio Goelett restano prenotabili circa quindici minuti dalla ricerca, e
 * il preventivo nasce con quella scadenza: scelta, dati anagrafici e prenotazione devono
 * starci dentro tutti. Mostrarlo non è un vezzo — senza, il viaggiatore non ha modo di
 * sapere che sta correndo, e scopre il problema quando la pagina gli dice che è scaduto.
 *
 * Non compare mai da solo: quando arriva a zero la pagina passa al pannello "scaduto".
 *
 * @param {Object} props
 * @param {number|null} props.msLeft - Millisecondi rimasti, già misurati sull'orologio del server
 */
export function DeadlineBadge({ msLeft }) {
  const { t } = useQuoteI18n()
  if (msLeft == null) return null

  const totalSeconds = Math.ceil(msLeft / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const urgent = msLeft <= URGENT_MS

  return (
    <div
      className={`gq-deadline${urgent ? ' gq-deadline--urgent' : ''}`}
      // Il tempo che scorre non va riletto per intero ogni secondo da uno screen reader:
      // il valore resta leggibile a richiesta, ma non si annuncia da sé.
      aria-live="off"
    >
      <span aria-hidden="true">⏱️</span>
      <span className="gq-deadline__label">{t.deadline.label}</span>
      <strong className="gq-deadline__value">
        {minutes}:{String(seconds).padStart(2, '0')}
      </strong>
      <span className="gq-deadline__hint">{t.deadline.hint}</span>
    </div>
  )
}
